<mat-drawer-container
	(backdropClick)="discardChangesAndCloseDrawer()"
	class="fixed h-full w-full z-nuclear top-0 right-0"
	[ngClass]="{ 'pointer-events-none': !(opened$ | async) }"
>
	<mat-drawer mode="over" position="end" [opened]="opened$ | async">
		<div class="flex flex-col gap-5 h-full max-h-full">
			<div class="flex justify-between items-center p-4">
				<h3>Edit Deposit Details</h3>
				<app-button
					size="small"
					[icon]="ICON.XMARK"
					btn="clear"
					(onClick)="discardChangesAndCloseDrawer()"
					[testHook]="testHooks.XmarkButton"
				></app-button>
			</div>

			<div class="border-b border-grey-light mb-3"></div>

			<div class="p-4 grow overflow-y-auto">
				<div class="flex flex-col gap-5">
					<div>
						<app-deposit-holder-dropdown
							#depositHolderDropdown
							[mode]="depositHolderDropdownMode.PASSTHROUGH_SELECTION"
							(onDepositHolderSelect)="onDepositHolderSelect($event)"
						>
						</app-deposit-holder-dropdown>
					</div>

					<div class="flex justify-between items-center">
						<h3 class="text-lg">Deposits</h3>
						<app-button
							[icon]="ICON.ADD"
							btn="primary"
							(onClick)="addDeposit()"
							[testHook]="testHooks.AddButton"
						></app-button>
					</div>

					<div class="deposit-list flex flex-col gap-6 mt-3">
						<ng-container
							*ngFor="
								let deposit of (vm$ | async)?.deposits;
								let i = index;
								trackBy: depositTrackByFn
							"
						>
							<div class="deposit-item flex flex-col gap-3">
								<div class="flex justify-between items-center">
									<h3 class="text-base">Deposit {{ i + 1 }}</h3>
									<app-button
										btn="tertiary"
										[icon]="ICON.DELETE"
										[holdable]="true"
										(onClick)="removeDeposit(i)"
										[testHook]="testHooks.DeleteButton"
									></app-button>
								</div>
								<app-input
									type="cents"
									label="Deposit Amount"
									name="amount"
									class="mt-3"
									[startIcon]="ICON.DOLLAR"
									[ngModel]="deposit.amount"
									(debounce)="updateDepositAmount($event, i)"
									[testHook]="testHooks.DepositAmount"
								></app-input>
								<app-date-picker
									label="Date"
									name="date"
									[ngModel]="deposit.date"
									(ngModelChange)="updateDepositDate($event, i)"
									[testHook]="testHooks.DateDatePicker"
								></app-date-picker>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			<div class="border-t border-grey-light mt-5">
				<div class="flex justify-start p-4">
					<app-button
						btn="primary"
						(onClick)="saveChangesAndCloseDrawer()"
						[testHook]="testHooks.SaveButton"
						>Save</app-button
					>
				</div>
			</div>
		</div>
	</mat-drawer>
</mat-drawer-container>
